var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container",style:(_vm.fileList.length ? 'margin-bottom: -20px;' : '')},_vm._l((_vm.fileList),function(item){return _c('ViewFileItem',{key:item.path,attrs:{"file":item,"del":false}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }